module.exports = __webpack_public_path__ + "static/media/Utn.c80b5ed2.jpeg";